import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { connect } from 'react-redux'

import Waypoint from './Waypoint'
import {
  doAddWaypoint,
  setWaypoints,
  makeRequest,
} from 'actions/directionsActions'

import { 
  mapGetGeoJsonObject, 
  mapGetGeoJsonObjectCenter, 
  isInsidePolygon,
  mapClearAllLayerContents,
} from 'utils/mapUtils';
import { 
  default_DstGeoJsonId, 
} from 'utils/mapGeoJson';
import { 
  polygon_UmEmap,
  coord_defaultSrc,
  coord_defaultDst,
  coord_defaultLocateMe,
} from 'utils/mapCoords';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  paddingLeft: 16,
  paddingRight: 16,
  //background: isDragging ? 'lightgreen' : 'transparent',
  // styles we need to apply on draggables
  ...draggableStyle,
})

class Waypoints extends Component {
  static propTypes = {
    directions: PropTypes.object,
    dispatch: PropTypes.func,
    map: PropTypes.object,
    activeLang: PropTypes.string.isRequired,     
    geoJsonId: PropTypes.string,
    srcCoord: PropTypes.string,   
    showDirectionButton: PropTypes.bool.isRequired,
    setShowDirectionButton: PropTypes.func.isRequired,    
  }

  constructor(props) {
    super(props)
    this.onDragEnd = this.onDragEnd.bind(this)
    this.state = { visible: false }
  }

  handleDismiss = () => {
    this.setState({ visible: false })
  }

  checkIfValidFirstWaypoints(waypoints) {
    return (
      Array.isArray(waypoints) &&
      waypoints.length >=1 &&
      waypoints[0].userInput &&
      waypoints[0].userInput.trim() !== ''
    );
  }

  checkIfValidSecondWaypoints(waypoints) {
    return (
      Array.isArray(waypoints) &&
      waypoints.length >= 2 &&
      waypoints[1].userInput &&
      waypoints[1].userInput.trim() !== ''
    );
  }  

  componentDidMount = () => {

    const { dispatch, directions, activeLang, geoJsonId, srcCoord } = this.props
    
    const current_waypoints = this.props.directions.waypoints;
    const firstWaypointValid = this.checkIfValidFirstWaypoints(current_waypoints);
    const secondWaypointValid = this.checkIfValidFirstWaypoints(current_waypoints);
    //console.log("current_waypoints", current_waypoints)
    //console.log("Is firstWaypointValid:", firstWaypointValid);
    //console.log("Is secondWaypointValid:", secondWaypointValid);

    this.setState({ visible: true })

    /* This is offical code, keep it for reference
    if (directions.waypoints.length === 0) {
      Array(2)
        .fill()
        .map((_, i) => dispatch(doAddWaypoint()))
    }
    */
    
    // Define the variables
    let SrcGeoJsonId, DstGeoJsonId;
    let geoJsonCoord1, geoJsonCoord2;
    let title1, title2, userInput1, userInput2;
    let geoJsonObject1, geoJsonObject2;
    
    // Initial the variables
    SrcGeoJsonId = null; 
    DstGeoJsonId = default_DstGeoJsonId;
    geoJsonCoord1= coord_defaultSrc;
    geoJsonCoord2= coord_defaultDst;
    
    if (geoJsonId) {
      DstGeoJsonId = geoJsonId; 
    }    
    geoJsonObject1 = mapGetGeoJsonObject(SrcGeoJsonId)
    geoJsonObject2 = mapGetGeoJsonObject(DstGeoJsonId)
    
    if (activeLang === 'zh') {
      title1 = "我的位置"
    } else {
      title1 = "My Location"
    }
    title2 = geoJsonObject2.properties.name;    

    
    
    if (srcCoord) { 
      const arraySrcCoord = srcCoord.split(',').map(Number);         
      if (isInsidePolygon(arraySrcCoord, polygon_UmEmap)) {
        geoJsonCoord1 = arraySrcCoord;   
      } else {        
        if (activeLang === 'zh') {
          title1 = "我的位置"
        } else {
          title1 = "My Location"
        }
        geoJsonCoord1 = coord_defaultLocateMe; // LIB   
      }
    }     

    geoJsonCoord2 = mapGetGeoJsonObjectCenter(DstGeoJsonId);

    const coordinates1 = [geoJsonCoord1[1], geoJsonCoord1[0]];
    const coordinates2 = [geoJsonCoord2[1], geoJsonCoord2[0]];

    userInput1 = title1;
    userInput2 = title2;

    // preset waypoints 0 and 1
    const waypoint1 = {
      id: "0",
      geocodeResults: [
        {
          title: title1,
          description: "",
          selected: true,
          addresslnglat: coordinates1,
          sourcelnglat: coordinates1,
          displaylnglat: coordinates1,
          key: 0,
          addressindex: 0,
          umresult: geoJsonObject1,
        },
      ],
      isFetching: false,
      userInput: userInput1,
    };

    const waypoint2 = {
      id: "1",
      geocodeResults: [
        {
          title: title2,
          description: "",
          selected: true,
          addresslnglat: coordinates2,
          sourcelnglat: coordinates2,
          displaylnglat: coordinates2,
          key: 0,
          addressindex: 0,
          umresult: geoJsonObject2,
        },
      ],
      isFetching: false,
      userInput: userInput2,
    };

    const emptyWayPoint = {
      id: "1",
      geocodeResults: [
        {
          title: "",
          description: "",
          selected: true,
          addresslnglat: "",
          sourcelnglat: "",
          displaylnglat: "",
          key: 0,
          addressindex: 0,
          umresult: null,
        },
      ],
      isFetching: false,
      userInput: userInput2,
    };    

    let newWaypoints;
    if (!firstWaypointValid && !secondWaypointValid) {
      if (geoJsonId) {
        //if (map) {
        //  mapClearAllLayerContents(map);      
        //}      
        newWaypoints = [waypoint1, waypoint2];
        dispatch(setWaypoints(newWaypoints));        
        dispatch(makeRequest()); 
      } else {
        //if (map) {
        //  mapClearAllLayerContents(map);      
        //}             
        newWaypoints = [waypoint1];
        dispatch(setWaypoints(newWaypoints));
        dispatch(doAddWaypoint());        
      }
    } else if (firstWaypointValid && secondWaypointValid) {
        dispatch(makeRequest()); 
    }
    /*
    if (geoJsonId) {
      newWaypoints = [waypoint1, waypoint2];
      dispatch(setWaypoints(newWaypoints));
      dispatch(makeRequest());          
    } else {
      newWaypoints = [waypoint1];
      dispatch(setWaypoints(newWaypoints));
      dispatch(doAddWaypoint());
    }
    */
  }


  componentDidUpdate(prevProps) {
    const current_waypoints = this.props.directions.waypoints;
    
    //console.log("Waypoints componentDidUpdate:", current_waypoints);
    let valid_waypoints = false;
    
    const checkSelected = (waypoint) => {
      return waypoint.geocodeResults.some(result => result.selected);
    };
    
    if (current_waypoints[0] && current_waypoints[0].userInput !== '' && current_waypoints[0].geocodeResults) {
      if (current_waypoints[1] && current_waypoints[1].userInput !== '' && current_waypoints[1].geocodeResults) {
        if (checkSelected(current_waypoints[0]) && checkSelected(current_waypoints[1])) {
          valid_waypoints = true;
        }
      }
    }    
    
    this.props.setShowDirectionButton(valid_waypoints);
    //console.log("valid_waypoints:", valid_waypoints);
    //console.log("showDirectionButton:", this.props.showDirectionButton);

    //this.props.setShowDirectionButton(valid_waypoints, () => {
    //  console.log("valid_waypoints:", valid_waypoints);
    //  console.log("showDirectionButton:", this.props.showDirectionButton);
    //});
      
  }
    
  
  onDragEnd(result) {
    // dropped outside the list

    if (!result.destination) {
      return
    }

    const { dispatch, directions } = this.props

    const items = reorder(
      directions.waypoints,
      result.source.index,
      result.destination.index
    )
    //console.log("items:", items)
    dispatch(setWaypoints(items))
    dispatch(makeRequest())
  }

  render() {
    const { waypoints } = this.props.directions
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <React.Fragment>
              <div
                className="flex flex-column"
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{ minHeight: '22rem' }}
              >
                {waypoints.map((wp, index) => (
                  <Draggable key={wp.id} draggableId={wp.id} index={index}>
                    {(provided_inner, snapshot_inner) => (
                      <div
                        ref={provided_inner.innerRef}
                        {...provided_inner.draggableProps}
                        {...provided_inner.dragHandleProps}
                        style={getItemStyle(
                          snapshot_inner.isDragging,
                          provided_inner.draggableProps.style
                        )}
                      >
                        <Waypoint
                          id={wp.id}
                          index={index}
                          value={wp.text}
                          geocodeResults={wp.geocodeResults}
                          map={this.props.map}
                          activeLang={this.props.activeLang} 
                          geoJsonId={this.props.geoJsonId} 
                          srcCoord={this.props.srcCoord}                           
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            </React.Fragment>
          )}
        </Droppable>
      </DragDropContext>
    )
  }
}

const mapStateToProps = (state) => {
  const { directions } = state
  return {
    directions,    
  }
}

export default connect(mapStateToProps)(Waypoints)
